import { ConfigFileSection } from '../../types';
import * as React from 'react';
import Button, { ButtonProps } from 'antd/lib/button';
import Text from 'antd/lib/typography/Text';
import { antGrey, titleStyle } from '../styles/globalStyles';
import { RunwayUserAction } from '../../helpers/aclHelpers';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';

interface BuildSubmoduleHeaderProps {
    title: string;
    ctaTitle?: string;
    ctaPermissionActionType?: RunwayUserAction;
    ctaPermissionReleaseId?: string;
    ctaConfigFileSection?: ConfigFileSection;
    ctaButtonProps?: ButtonProps;
}

const BuildSubmoduleHeader: React.FC<BuildSubmoduleHeaderProps> = (props: BuildSubmoduleHeaderProps) => {
    const ctaReactNode = () => {
        if (props.ctaPermissionActionType) {
            return (
                <PermissionedActionButton
                    releaseId={props.ctaPermissionReleaseId}
                    actionType={props.ctaPermissionActionType}
                    configFileSection={props.ctaConfigFileSection}
                    type="link"
                    {...props.ctaButtonProps}
                >
                    {props.ctaTitle}
                </PermissionedActionButton>
            );
        } else {
            return (
                <Button {...props.ctaButtonProps} type="link" style={{ padding: 0 }}>
                    {props.ctaTitle}
                </Button>
            );
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 12,
                minHeight: 30,
            }}
        >
            <Text style={{ ...titleStyle, color: antGrey.grey7, fontSize: 12 }}>{props.title}</Text>

            {props.ctaTitle && ctaReactNode()}
        </div>
    );
};

export default BuildSubmoduleHeader;
